export enum ColorFormats {
    HEX,
    RGBA,
    HSLA,
    CMYK
  }